import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

// initial state
const state = {
    sso_enabled: false
}

const actions = {
    [action_types.SSO_ENABLED] (context, {sso_enabled}) {
        context.commit(mutation_types.SSO_ENABLED_SET, {sso_enabled: sso_enabled});
    }
}

// mutations
const mutations = {
    [mutation_types.SSO_ENABLED_SET] (state, {sso_enabled}) {
        state.sso_enabled = sso_enabled;
    },
}

export default {
    state,
    actions,
    mutations
}
